import clsx from "clsx";
import type { ComponentProps } from "react";

import s from "./loading-spinner.module.scss";

export type CompProps = ComponentProps<"div"> & {
  className?: string;
};

export const LoadingSpinner = (props: CompProps) => {
  const { className } = props;

  return (
    <div className={clsx(s.root, className)}>
      <div className={clsx(s.circle, s.circle1)}></div>
      <div className={clsx(s.circle, s.circle2)}></div>
      <div className={clsx(s.circle, s.circle3)}></div>
    </div>
  );
};

LoadingSpinner.displayName = "LoadingSpinner";
